import axios from 'axios'
import { checkStatus, parseJSON } from './responseHandler'
// import { MERCHANDISE_URL } from '../utils/constant'
import Vue from 'vue'
import VueCookie from 'vue-cookie'


Vue.use(VueCookie);

// Make an api call

export default async (base_url, url, method = 'post', body) => {
  let headers = {
    'Content-Type': 'application/json',
    'X-Auth-Id': VueCookie.get('X-Auth-Id') ? VueCookie.get('X-Auth-Id') : '',
    // 'X-AUTH-TOKEN': VueCookie.get('X-Auth-Token'),
    'source': 'Mall91',
    'lang': VueCookie.get('lang') || 'hi' ,
    'Authorization':`Bearer ${VueCookie.get('JWT-TOKEN')}` 

  }
  return axios(`${base_url}${url}`, {
    method,
    data: JSON.stringify(body),
    headers
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch(error => {
      throw error
    })
}

